<template>
    <div class="kgr-row">
        <kgr-form-row
            :label="$t('area.name')"
            :error="error"
            field-name="name"
            required
        >
            <input
                v-model.trim="area.name"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            v-show="isNew"
            :label="$t('location.fieldName')"
            :error="error"
            field-name="fieldName"
            required
        >
            <input
                v-model.trim="area.fieldName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('area.note')"
            :error="error"
            field-name="note"
        >
            <textarea
                v-model.trim="area.note"
                class="kgr-input"
                rows="5"
            ></textarea>
        </kgr-form-row>

        <kgr-form-row
            :label="$t('area.size')"
            :error="error"
            field-name="size"
        >
            <input
                v-model.number="area.size"
                type="number"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('area.maxPersons')"
            :error="error"
            field-name="maxPersons"
        >
            <input
                v-model.number="area.maxPersons"
                type="number"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';

export default {
    components: {
        'kgr-form-row': FormRow,
    },
    props: {
        area: {
            type: Object,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            isNew: true,
        };
    },
    created() {
        if (this.area.id) {
            this.isNew = false;
        }
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },

};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
